export enum ServiceFocusType {
    Primary = 1,
    Hybrid = 2,
    Other = 3
}
